import ListFields from '../fragments/ListFields';

export default (languageCode: string) => /* GraphQL */ `
    mutation RemoveItems($itemNos: [ID!]!, $listId: ID) {
        list: removeItems(itemNos: $itemNos, listId: $listId, itemPresentation: { languageCode: "${languageCode}" }) {
            ...ListFields
        }
    }
    ${ListFields}
`;
